'use client';

import { useEffect, useState } from 'react';

interface TableOfContentsProps {
  items: Array<{ text: string; id: string }>;
}

export default function TableOfContents({ items }: TableOfContentsProps) {
  const [activeId, setActiveId] = useState<string>('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // 找到所有正在 intersecting 的元素
        const intersectingEntries = entries.filter(entry => entry.isIntersecting);

        if (intersectingEntries.length > 0) {
          // 选择最接近顶部的元素
          const topmost = intersectingEntries.reduce((prev, current) => {
            return prev.boundingClientRect.top < current.boundingClientRect.top ? prev : current;
          });
          setActiveId(topmost.target.id);
        }
      },
      {
        rootMargin: '-84px 0px -80% 0px',
        threshold: 0
      }
    );

    items.forEach(({ id }) => {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      items.forEach(({ id }) => {
        const element = document.getElementById(id);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, [items]);

  return (
    <div>
      {items.map(({ text, id }) => (
        <div
          key={id + text}
          className={`mb-[24px] cursor-pointer transition-colors ${
            id === activeId ? 'text-[#FF596C]' : 'text-[#ABAAA6] hover:text-[#FF596C]'
          }`}
          style={{
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: '500',
          }}
            onClick={() => {
            const element = document.getElementById(id);
            if (element) {
              const offset = 84;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
              });
            }
          }}
        >
          {text}
        </div>
      ))}
    </div>
  );
}

